import React from 'react';
import NextBtn from './NextBtn'

const Heading = (props) => {
    return <div className="si-heading-section si-flexBox">
        <span className="si-title">{props.title}</span>
        {props.captainText ? <span className="si-secondary-title">{props.captainText}</span> : null}
        <div className="si-save-data">
            <NextBtn {...props} />
        </div>
    </div>
};
export default Heading;


// WEBPACK FOOTER //
// ./src/components/onboarding/Heading.js